/* it7 ⇄ Swym Wishlist Plus bridge (2026-06-12)
   Keeps the it7 wishlist UI (hearts, PDP button + View Wishlist slide-in, header
   count) exactly as designed, but makes Swym the durable backend:
   - On load, Swym's list is fetched and mirrored into the `it7wish` localStorage
     key that all existing inline painters already read → instant, consistent UI.
   - Clicks keep their optimistic localStorage toggle (zero-latency animation);
     this adapter observes the click one tick later and syncs the add/remove to
     Swym via their v3 JS API (epi = variant id, empi = product id, du = URL,
     carried as data attributes on the buttons).
   Swym's own injected buttons/launcher must be disabled in the Swym admin.
   NOTE (2026-06-12): on this store Swym initializes unreliably — the
   window.SwymCallbacks queue is never drained (their relay extension errors
   during init) and in some sessions window._swat never appears at all. So:
   - we poll for window._swat as well as queueing the callback, and
   - every wishlist click ALSO records {empi → du, epi} in the `it7wishd`
     localStorage map, independent of Swym, so the wishlist page can render
     saved items even when Swym is completely dead. */
(function () {
  var KEY = 'it7wish';
  var DKEY = 'it7wishd';
  function lsGet() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function lsSet(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function dGet() { try { return JSON.parse(localStorage.getItem(DKEY) || '{}'); } catch (e) { return {}; } }
  function dSet(o) { try { localStorage.setItem(DKEY, JSON.stringify(o)); } catch (e) {} }

  function paint() {
    var w = lsGet();
    document.querySelectorAll('.hrt[data-it7-wish]').forEach(function (b) {
      var on = w.indexOf(b.dataset.it7Wish) > -1;
      b.classList.toggle('on', on);
      b.textContent = on ? '♥' : '♡';
    });
    var wb = document.getElementById('it7-wshbtn');
    if (wb) {
      var on = w.indexOf(wb.dataset.it7Wish) > -1;
      wb.classList.toggle('on', on);
      wb.innerHTML = on ? '♥' : '♡';
      wb.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var wl = document.getElementById('it7-wishlink');
    if (wl) { var n = w.length; wl.textContent = n > 0 ? 'Wishlist (' + n + ')' : 'Wishlist'; }
  }

  /* Swym-independent: keep the empi→{du,epi} detail map in step with every
     wishlist click so the wishlist page can render without Swym. */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-it7-wish]');
    if (!el) return;
    setTimeout(function () {
      var id = el.dataset.it7Wish;
      if (!id) return;
      var d = dGet();
      if (lsGet().indexOf(id) > -1) {
        d[id] = { du: el.dataset.it7Du || (location.origin + location.pathname), epi: el.dataset.it7Epi || '' };
        /* ITA2-933: wishlist adds previously emitted NO analytics event. Fire a
           Klaviyo "Added to Wishlist" event on the ADD toggle only (not remove),
           using the identifiers already on the button. Guarded so it never throws
           if the Klaviyo SDK hasn't loaded — analytics must not break the UX. */
        try {
          if (window._learnq) {
            window._learnq.push(['track', 'Added to Wishlist', {
              ProductID: id,
              VariantID: el.dataset.it7Epi || undefined,
              URL: d[id].du
            }]);
          }
        } catch (err) { /* never break the wishlist toggle on analytics failure */ }
      } else {
        delete d[id];
      }
      dSet(d);
    }, 0);
  });

  var swat = null;
  var swymList = [];

  function syncFromSwym() {
    if (!swat) return;
    try {
      swat.fetch(function (list) {
        swymList = list || [];
        lsSet(swymList.map(function (i) { return String(i.empi); }));
        var d = dGet();
        swymList.forEach(function (i) { if (i.du) d[String(i.empi)] = { du: i.du, epi: i.epi || '' }; });
        dSet(d);
        paint();
      });
    } catch (e) { /* Swym unavailable — UI keeps working on localStorage alone */ }
  }

  function init(_swat) {
    if (swat || !_swat) return; /* bind once, whichever path fires first */
    swat = _swat;
    syncFromSwym();

    /* Observe wishlist clicks one tick after the inline optimistic handlers ran,
       then push the resulting state to Swym (idempotent on their side). */
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-it7-wish]');
      if (!el || !swat) return;
      setTimeout(function () {
        var id = el.dataset.it7Wish;
        var empi = parseInt(id, 10);
        if (!empi) return;
        var on = lsGet().indexOf(id) > -1;
        var epi = parseInt(el.dataset.it7Epi || '', 10) || empi;
        var du = el.dataset.it7Du || (location.origin + location.pathname);
        if (on) {
          try { swat.addToWishList({ epi: epi, empi: empi, du: du }, function () { syncFromSwym(); }); } catch (err) {}
        } else {
          var item = swymList.filter(function (i) { return String(i.empi) === id; })[0] || { epi: epi, empi: empi, du: du };
          try { swat.removeFromWishList(item, function () { syncFromSwym(); }); } catch (err) {}
        }
      }, 0);
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(init);

  /* Fallback: poll for window._swat for up to ~60s; the callbacks queue is not
     drained on this store, so this is the path that actually binds in practice. */
  var tries = 0;
  var poll = setInterval(function () {
    if (swat) { clearInterval(poll); return; }
    if (window._swat) { clearInterval(poll); init(window._swat); }
    else if (++tries > 200) { clearInterval(poll); }
  }, 300);
})();
